import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { SharedModule } from '../../shared/shared.module';;
import { OwlModule} from 'angular-owl-carousel';
import { ReactiveFormsModule } from '@angular/forms';
import {PlanComponent} from './plan.component';

@NgModule({
	declarations: [
		PlanComponent
	],

	imports: [
		CommonModule,
		RouterModule,
		NgbModule,
		SharedModule,
		OwlModule,
		LazyLoadImageModule,
		ReactiveFormsModule
	]
})

export class PlanModule { }
